import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VTextField,{staticClass:"g-field",attrs:{"label":"Serial","single-line":"","hide-details":"auto","outlined":"","dense":"","clearable":"","loading":_vm.loading,"disabled":_vm.disabled},model:{value:(_vm.fieldValue),callback:function ($$v) {_vm.fieldValue=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"fieldValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }